<template>
	<div>
		<el-tabs v-model="activeTab" @tab-click="handleTabClick">
			<el-tab-pane label="基本信息" name="claimDetail"></el-tab-pane>
			<el-tab-pane label="工单" name="claimProcess" v-if="dealFlag == '1'"></el-tab-pane>
			<el-tab-pane label="日志" name="claimLog"></el-tab-pane>
		</el-tabs>
		<transition name="fade-transform" mode="out-in">
			<router-view :key="key" />
		</transition>
	</div>
</template>

<script>
export default {
	data() {
		return {
			activeTab: this.$route.name, // 初始化为当前路由name
			dealFlag: "1",
		};
	},
	computed: {
		key() {
			return this.$route.path;
		},
	},
	watch: {
		// 监听路由变化，同步更新activeTab
		$route(to) {
			this.activeTab = to.name;
			this.setDealFlag();
		},
	},
	created() {
		this.setDealFlag();
	},
	methods: {
		handleTabClick(tab) {
			this.setDealFlag();
			// 点击tab时跳转到对应路由
			this.$router.push({
				name: tab.name,
			});
		},
		setDealFlag() {
			const dealFlag = sessionStorage.getItem("dealFlag");
			this.dealFlag = [null, undefined].includes(dealFlag) ? "1" : dealFlag;
		},
	},
};
</script>
